import { SPB, SPB_REGION } from '../../constants/regions';

export const isSPBiLO = (locationId: number) => {
  return [SPB, SPB_REGION].includes(locationId);
};
